import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_awswaf_ec927cfc from 'nuxt_plugin_awswaf_ec927cfc' // Source: ../plugins/aws-waf.js (mode: 'client')
import nuxt_plugin_googletagmanager_515a7cec from 'nuxt_plugin_googletagmanager_515a7cec' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_pluginschat3aa768cc_870663e4 from 'nuxt_plugin_pluginschat3aa768cc_870663e4' // Source: ./plugins.chat.3aa768cc.js (mode: 'client')
import nuxt_plugin_pluginseo_423d5d49 from 'nuxt_plugin_pluginseo_423d5d49' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_plugin_bfd0ca6c from 'nuxt_plugin_plugin_bfd0ca6c' // Source: ./api/plugin.js (mode: 'all')
import nuxt_plugin_index_3c1c0307 from 'nuxt_plugin_index_3c1c0307' // Source: ./auth/index.js (mode: 'all')
import nuxt_plugin_pluginsaffiliate18395322_ad3273d0 from 'nuxt_plugin_pluginsaffiliate18395322_ad3273d0' // Source: ./plugins.affiliate.18395322.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_storegeod3bf626c_644bd3ec from 'nuxt_plugin_storegeod3bf626c_644bd3ec' // Source: ./store.geo.d3bf626c.js (mode: 'all')
import nuxt_plugin_pluginsclassification0a7e8ae8_f297caf2 from 'nuxt_plugin_pluginsclassification0a7e8ae8_f297caf2' // Source: ./plugins.classification.0a7e8ae8.js (mode: 'all')
import nuxt_plugin_storeclassification670d800d_932984c0 from 'nuxt_plugin_storeclassification670d800d_932984c0' // Source: ./store.classification.670d800d.js (mode: 'all')
import nuxt_plugin_pluginslang98f88578_c38f46ca from 'nuxt_plugin_pluginslang98f88578_c38f46ca' // Source: ./plugins.lang.98f88578.js (mode: 'all')
import nuxt_plugin_api_69c16542 from 'nuxt_plugin_api_69c16542' // Source: ./core/util/api.js (mode: 'all')
import nuxt_plugin_controller_26bf86d9 from 'nuxt_plugin_controller_26bf86d9' // Source: ./core/util/controller.js (mode: 'all')
import nuxt_plugin_api_1a27a1e5 from 'nuxt_plugin_api_1a27a1e5' // Source: ./core/bank/api.js (mode: 'all')
import nuxt_plugin_controller_bd63a0da from 'nuxt_plugin_controller_bd63a0da' // Source: ./core/bank/controller.js (mode: 'all')
import nuxt_plugin_api_ec639794 from 'nuxt_plugin_api_ec639794' // Source: ./core/client/api.js (mode: 'all')
import nuxt_plugin_store_7e7829cf from 'nuxt_plugin_store_7e7829cf' // Source: ./core/client/store.js (mode: 'all')
import nuxt_plugin_controller_9682dfbc from 'nuxt_plugin_controller_9682dfbc' // Source: ./core/client/controller.js (mode: 'all')
import nuxt_plugin_toast_e867e216 from 'nuxt_plugin_toast_e867e216' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_pluginsanalytics2b786996_b49e366a from 'nuxt_plugin_pluginsanalytics2b786996_b49e366a' // Source: ./plugins.analytics.2b786996.js (mode: 'client')
import nuxt_plugin_pluginsuinossr8469f5c6_2c4580d4 from 'nuxt_plugin_pluginsuinossr8469f5c6_2c4580d4' // Source: ./plugins.ui-no-ssr.8469f5c6.js (mode: 'client')
import nuxt_plugin_pluginsui2396f99e_2cef6f13 from 'nuxt_plugin_pluginsui2396f99e_2cef6f13' // Source: ./plugins.ui.2396f99e.js (mode: 'all')
import nuxt_plugin_pluginstools3aa34cbe_43891382 from 'nuxt_plugin_pluginstools3aa34cbe_43891382' // Source: ./plugins.tools.3aa34cbe.js (mode: 'all')
import nuxt_plugin_pluginsshim317d8d19_329745b6 from 'nuxt_plugin_pluginsshim317d8d19_329745b6' // Source: ./plugins.shim.317d8d19.js (mode: 'all')
import nuxt_plugin_pluginsflowee0df3f8_cf5fce92 from 'nuxt_plugin_pluginsflowee0df3f8_cf5fce92' // Source: ./plugins.flow.ee0df3f8.js (mode: 'all')
import nuxt_plugin_adminmiddleware481e9acf_35fe9688 from 'nuxt_plugin_adminmiddleware481e9acf_35fe9688' // Source: ./admin.middleware.481e9acf.js (mode: 'all')
import nuxt_plugin_modulevalidator24f1d184_4c11fbc8 from 'nuxt_plugin_modulevalidator24f1d184_4c11fbc8' // Source: ./module.validator.24f1d184.js (mode: 'all')
import nuxt_plugin_assetsssr_6655ceba from 'nuxt_plugin_assetsssr_6655ceba' // Source: ./ui/assets.ssr.js (mode: 'client')
import nuxt_plugin_assets_5cb27844 from 'nuxt_plugin_assets_5cb27844' // Source: ./ui/assets.js (mode: 'all')
import nuxt_plugin_controller_f12e07b6 from 'nuxt_plugin_controller_f12e07b6' // Source: ./ui/controller.js (mode: 'all')
import nuxt_plugin_theme_ef36fbf8 from 'nuxt_plugin_theme_ef36fbf8' // Source: ./ui/theme.js (mode: 'all')
import nuxt_plugin_pluginsarithmetic39834fda_2db2ab76 from 'nuxt_plugin_pluginsarithmetic39834fda_2db2ab76' // Source: ./plugins.arithmetic.39834fda.js (mode: 'all')
import nuxt_plugin_index_cb02149c from 'nuxt_plugin_index_cb02149c' // Source: ./sandbox/index.js (mode: 'all')
import nuxt_plugin_calc_017c686a from 'nuxt_plugin_calc_017c686a' // Source: ../plugins/calc.js (mode: 'all')
import nuxt_plugin_mask_10a663d4 from 'nuxt_plugin_mask_10a663d4' // Source: ../plugins/mask.js (mode: 'all')
import nuxt_plugin_rules_21609a77 from 'nuxt_plugin_rules_21609a77' // Source: ../plugins/rules.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_chat24_373a1bb4 from 'nuxt_plugin_chat24_373a1bb4' // Source: ../plugins/chat24.js (mode: 'all')
import nuxt_plugin_seon_54a828ef from 'nuxt_plugin_seon_54a828ef' // Source: ../plugins/seon.js (mode: 'all')
import nuxt_plugin_vueslickcarousel_7805efe4 from 'nuxt_plugin_vueslickcarousel_7805efe4' // Source: ../plugins/vue-slick-carousel.js (mode: 'client')
import nuxt_plugin_api_78da0798 from 'nuxt_plugin_api_78da0798' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_services_21e040a2 from 'nuxt_plugin_services_21e040a2' // Source: ../plugins/services.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_awswaf_ec927cfc === 'function') {
    await nuxt_plugin_awswaf_ec927cfc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_515a7cec === 'function') {
    await nuxt_plugin_googletagmanager_515a7cec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginschat3aa768cc_870663e4 === 'function') {
    await nuxt_plugin_pluginschat3aa768cc_870663e4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_423d5d49 === 'function') {
    await nuxt_plugin_pluginseo_423d5d49(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_bfd0ca6c === 'function') {
    await nuxt_plugin_plugin_bfd0ca6c(app.context, inject)
  }

  if (typeof nuxt_plugin_index_3c1c0307 === 'function') {
    await nuxt_plugin_index_3c1c0307(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsaffiliate18395322_ad3273d0 === 'function') {
    await nuxt_plugin_pluginsaffiliate18395322_ad3273d0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_storegeod3bf626c_644bd3ec === 'function') {
    await nuxt_plugin_storegeod3bf626c_644bd3ec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsclassification0a7e8ae8_f297caf2 === 'function') {
    await nuxt_plugin_pluginsclassification0a7e8ae8_f297caf2(app.context, inject)
  }

  if (typeof nuxt_plugin_storeclassification670d800d_932984c0 === 'function') {
    await nuxt_plugin_storeclassification670d800d_932984c0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslang98f88578_c38f46ca === 'function') {
    await nuxt_plugin_pluginslang98f88578_c38f46ca(app.context, inject)
  }

  if (typeof nuxt_plugin_api_69c16542 === 'function') {
    await nuxt_plugin_api_69c16542(app.context, inject)
  }

  if (typeof nuxt_plugin_controller_26bf86d9 === 'function') {
    await nuxt_plugin_controller_26bf86d9(app.context, inject)
  }

  if (typeof nuxt_plugin_api_1a27a1e5 === 'function') {
    await nuxt_plugin_api_1a27a1e5(app.context, inject)
  }

  if (typeof nuxt_plugin_controller_bd63a0da === 'function') {
    await nuxt_plugin_controller_bd63a0da(app.context, inject)
  }

  if (typeof nuxt_plugin_api_ec639794 === 'function') {
    await nuxt_plugin_api_ec639794(app.context, inject)
  }

  if (typeof nuxt_plugin_store_7e7829cf === 'function') {
    await nuxt_plugin_store_7e7829cf(app.context, inject)
  }

  if (typeof nuxt_plugin_controller_9682dfbc === 'function') {
    await nuxt_plugin_controller_9682dfbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_e867e216 === 'function') {
    await nuxt_plugin_toast_e867e216(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginsanalytics2b786996_b49e366a === 'function') {
    await nuxt_plugin_pluginsanalytics2b786996_b49e366a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginsuinossr8469f5c6_2c4580d4 === 'function') {
    await nuxt_plugin_pluginsuinossr8469f5c6_2c4580d4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsui2396f99e_2cef6f13 === 'function') {
    await nuxt_plugin_pluginsui2396f99e_2cef6f13(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginstools3aa34cbe_43891382 === 'function') {
    await nuxt_plugin_pluginstools3aa34cbe_43891382(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsshim317d8d19_329745b6 === 'function') {
    await nuxt_plugin_pluginsshim317d8d19_329745b6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsflowee0df3f8_cf5fce92 === 'function') {
    await nuxt_plugin_pluginsflowee0df3f8_cf5fce92(app.context, inject)
  }

  if (typeof nuxt_plugin_adminmiddleware481e9acf_35fe9688 === 'function') {
    await nuxt_plugin_adminmiddleware481e9acf_35fe9688(app.context, inject)
  }

  if (typeof nuxt_plugin_modulevalidator24f1d184_4c11fbc8 === 'function') {
    await nuxt_plugin_modulevalidator24f1d184_4c11fbc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_assetsssr_6655ceba === 'function') {
    await nuxt_plugin_assetsssr_6655ceba(app.context, inject)
  }

  if (typeof nuxt_plugin_assets_5cb27844 === 'function') {
    await nuxt_plugin_assets_5cb27844(app.context, inject)
  }

  if (typeof nuxt_plugin_controller_f12e07b6 === 'function') {
    await nuxt_plugin_controller_f12e07b6(app.context, inject)
  }

  if (typeof nuxt_plugin_theme_ef36fbf8 === 'function') {
    await nuxt_plugin_theme_ef36fbf8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsarithmetic39834fda_2db2ab76 === 'function') {
    await nuxt_plugin_pluginsarithmetic39834fda_2db2ab76(app.context, inject)
  }

  if (typeof nuxt_plugin_index_cb02149c === 'function') {
    await nuxt_plugin_index_cb02149c(app.context, inject)
  }

  if (typeof nuxt_plugin_calc_017c686a === 'function') {
    await nuxt_plugin_calc_017c686a(app.context, inject)
  }

  if (typeof nuxt_plugin_mask_10a663d4 === 'function') {
    await nuxt_plugin_mask_10a663d4(app.context, inject)
  }

  if (typeof nuxt_plugin_rules_21609a77 === 'function') {
    await nuxt_plugin_rules_21609a77(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_chat24_373a1bb4 === 'function') {
    await nuxt_plugin_chat24_373a1bb4(app.context, inject)
  }

  if (typeof nuxt_plugin_seon_54a828ef === 'function') {
    await nuxt_plugin_seon_54a828ef(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslickcarousel_7805efe4 === 'function') {
    await nuxt_plugin_vueslickcarousel_7805efe4(app.context, inject)
  }

  if (typeof nuxt_plugin_api_78da0798 === 'function') {
    await nuxt_plugin_api_78da0798(app.context, inject)
  }

  if (typeof nuxt_plugin_services_21e040a2 === 'function') {
    await nuxt_plugin_services_21e040a2(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
